// import Main from '@/view/main'

export default {
  path: 'order',
  meta: {
    title: '销售管理'
  },
  component: () => import('@/components/parent-view'),
  name: 'order',
  children: [
    // 旧
    {
      path: '',
      meta: {
        title: '订单列表'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'list',
          meta: {
            title: '订单列表',
            ignoreBreadCrumb: true
          },
          name: 'self-order-list',
          component: () => import('@/view/self/order/index.vue')
        },
        {
          path: 'detail/:code',
          meta: {
            title: '订单详情',
            hideInTabBar: true,
            detail: true,
            edit: false
          },
          name: 'self-order-detail',
          component: () => import('@/view/self/order/detail.vue')
        },
        {
          path: 'edit/:code',
          meta: {
            title: '订单编辑',
            hideInTabBar: true,
            edit: true,
            pending: true
          },
          name: 'self-order-edit',
          component: () => import('@/view/self/order/detail.vue')
        },
        {
          path: 'audit/:code',
          meta: {
            title: '订单审批',
            hideInTabBar: true,
            audit: true,
            edit: false
          },
          name: 'self-order-audit',
          component: () => import('@/view/self/order/detail.vue')
        },
        {
          path: 'receive/:code',
          meta: {
            title: '提交签收单',
            hideInTabBar: true
          },
          name: 'self-order-received',
          component: () => import('@/view/self/order/received.vue')
        },
        {
          path: 'orderReceive/:code',
          meta: {
            title: '自建签收单',
            hideInTabBar: true
          },
          name: 'self-order-orderReceived',
          component: () => import('@/view/self/order/orderReceived.vue')
        },
        {
          path: 'gain/:code',
          meta: {
            title: '提货单详情',
            hideInTabBar: true
          },
          name: 'self-order-gain-detail',
          component: () => import('@/view/self/order/gainGoods')
        }
      ]
    },
    // 新
    {
      path: '',
      meta: {
        title: '订单列表'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'index',
          meta: {
            title: '订单列表',
            ignoreBreadCrumb: true
          },
          name: 'self-order-index',
          component: () => import('@/view/v5/order/index.vue')
        },
        {
          path: 'v5/detail/:orderId',
          meta: {
            title: '订单详情',
            hideInTabBar: true,
            detail: true,
            edit: false
          },
          name: 'self-order-detail',
          component: () => import('@/view/v5/order/detail.vue')
        },
        {
          path: 'v5/edit/:orderId',
          meta: {
            title: '订单编辑',
            hideInTabBar: true,
            edit: true,
            pending: true
          },
          name: 'self-order-edit',
          component: () => import('@/view/v5/order/detail.vue')
        },
        {
          path: 'v5/audit/:orderId',
          meta: {
            title: '订单审批',
            hideInTabBar: true,
            audit: true,
            edit: false
          },
          name: 'self-order-audit',
          component: () => import('@/view/v5/order/detail.vue')
        },
        {
          path: 'v5/receive/:code',
          meta: {
            title: '提交送货单',
            hideInTabBar: true,
            billType: 'FHD',
            detail: true,
            edit: false
          },
          name: 'self-order-received',
          component: () => import('@/view/v5/order/receiptOrder/detail.vue')
        },
        {
          path: 'back/:code',
          meta: {
            title: '提交退货单',
            hideInTabBar: true,
            billType: 'THD',
            detail: true,
            edit: false
          },
          name: 'self-order-back',
          component: () => import('@/view/v5/order/receiptOrder/backDetail.vue')
        },
        {
          path: 'orderReceive/:code',
          meta: {
            title: '自建签收单',
            hideInTabBar: true
          },
          name: 'self-order-orderReceived',
          component: () => import('@/view/v5/order/orderReceived.vue')
        },
        {
          path: 'gain/:code',
          meta: {
            title: '提货单详情',
            hideInTabBar: true
          },
          name: 'self-order-gain-detail',
          component: () => import('@/view/v5/order/gainGoods')
        }
      ]
    },
    {
      path: 'query',
      name: 'sale-query',
      meta: {
        title: '订单查询'
      },
      component: () => import('@/view/v5/order/saleQuery/index.vue')
    },
    {
      path: 'receipt',
      meta: {
        title: '送货单列表'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'list',
          meta: {
            title: '送货单列表',
            ignoreBreadCrumb: true,
            billType: 'FHD'
          },
          name: 'self-receipt-order-list',
          component: () => import('@/view/v5/order/receiptOrder/index.vue')
        },
        {
          path: 'query',
          meta: {
            title: '送货单查询'
          },
          name: 'self-receipt-order-query',
          component: () => import('@/view/v5/order/receiptOrder/query/send.vue')
        }
      ]
    },
    {
      path: 'receiptBack',
      meta: {
        title: '退货单列表'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'list',
          meta: {
            title: '退货单列表',
            ignoreBreadCrumb: true,
            billType: 'THD'
          },
          name: 'self-receipt-back-order-list',
          component: () => import('@/view/v5/order/receiptOrder/backOrder.vue')
        },
        {
          path: 'query',
          meta: {
            title: '退货单查询'
          },
          name: 'self-receipt-back-order-query',
          component: () => import('@/view/v5/order/receiptOrder/query/back.vue')
        }
      ]
    },
    {
      path: 'newBack',
      meta: {
        title: '新建退货单',
        hideInTabBar: true,
        isAdd: true
      },
      name: 'self-order-new-back',
      component: () => import('@/view/v5/order/receiptOrder/backDetail.vue')
    },
    {
      path: 'back/:code',
      meta: {
        title: '提交退货单',
        hideInTabBar: true,
        detail: true
      },
      name: 'self-order-back',
      component: () => import('@/view/v5/order/backOrder.vue')
    },
    {
      path: 'search',
      name: 'self-order-search',
      meta: {
        title: '订单查询'
      },
      component: () => import('@/view/v5/order/search.vue')
    },
    {
      path: 'import',
      name: 'self-order-import',
      meta: {
        title: '订单导入（旧）'
      },
      component: () => import('@/view/self/order/import-order.vue')
    },
    {
      path: 'importV5',
      name: 'self-order-import-v5',
      meta: {
        title: '订单导入'
      },
      component: () => import('@/view/v5/order/import-order.vue')
    },
    {
      path: 'importOrderV5',
      name: 'self-order-import-order-v5',
      meta: {
        title: '订单导入v2'
      },
      component: () => import('@/view/v5/order/importOrder2.vue')
    },
    {
      path: 'replace',
      name: 'self-order-replace',
      meta: {
        title: '代客下单'
      },
      component: () => import('@/view/v5/order/replace-order.vue')
    },
    {
      path: 'selfOrder',
      name: 'self-order-selfOrder',
      meta: {
        title: '自建订单'
      },
      component: () => import('@/view/v5/order/selfOrder.vue')
    },
    {
      path: 'saleOrder',
      name: 'self-order-saleOrder',
      meta: {
        title: '销售订单'
      },
      component: () => import('@/view/v5/order/saleOrder.vue')
    },
    {
      path: 'sale/edit',
      name: 'self-order-saleOrder-edit',
      meta: {
        title: '编辑销售订单'
      },
      component: () => import('@/view/v5/order/editSaleOrder.vue')
    },
    {
      path: 'payment',
      meta: {
        title: '到账管理',
        notCache: false
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'cache-self-sales-payment',
          meta: {
            title: '到账管理',
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/statement/payment/index.vue')
        },
        {
          path: `org/:orgId`,
          name: 'sales-payment-org-details',
          meta: {
            title: '会员详情',
            hideInTabBar: true
          },
          component: () => import('@/view/member/org-query/details.vue')
        },
        {
          path: 'project/:code',
          meta: {
            title: '项目详情',
            hideInTabBar: true
          },
          name: 'self-sales-projcet',
          component: () => import('@/view/v5/statement/project.vue')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/v5/order.js